import { render, staticRenderFns } from "./NoLocal.vue?vue&type=template&id=6b736898&scoped=true"
import script from "./NoLocal.vue?vue&type=script&lang=js"
export * from "./NoLocal.vue?vue&type=script&lang=js"
import style0 from "./NoLocal.vue?vue&type=style&index=0&id=6b736898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b736898",
  null
  
)

export default component.exports